import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_report_loader = _resolveComponent("report-loader")!
  const _component_report_posts = _resolveComponent("report-posts")!
  const _component_report_toolbar = _resolveComponent("report-toolbar")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { padding: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_report_loader, {
        "report-id": _ctx.reportId,
        modelValue: _ctx.report,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.report) = $event))
      }, null, 8, ["report-id", "modelValue"]),
      (_ctx.report)
        ? (_openBlock(), _createBlock(_component_report_posts, {
            key: 0,
            "report-id": _ctx.reportId,
            style: {"margin-top":"3rem"},
            onTrashed: _ctx.modified,
            onRestored: _ctx.modified
          }, null, 8, ["report-id", "onTrashed", "onRestored"]))
        : _createCommentVNode("", true),
      (_ctx.report)
        ? (_openBlock(), _createBlock(_component_q_page_sticky, {
            key: 1,
            expand: "",
            position: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_report_toolbar, {
                report: _ctx.report,
                class: "fit bg-white shadow-1"
              }, null, 8, ["report"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}